import { render, staticRenderFns } from "./RatingQ.vue?vue&type=template&id=29dab80e&"
import script from "./RatingQ.vue?vue&type=script&lang=ts&"
export * from "./RatingQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports